import {Observable, Subscriber} from "rxjs";
import {PopupMessage, PopupMessageType} from "@app/presentation/components/errors/popup.message";
import {ErrorsManager} from "@app/presentation/components/errors/errors.manager";
import {NavigationAction} from "@app/core/shared/domain/entities/navigation-action";

export class PopupNotifier {
    emitter!: Subscriber<PopupMessage | NavigationAction>
    messageObservable: Observable<PopupMessage | NavigationAction> = new Observable<PopupMessage>(emitter => this.emitter = emitter)

    static errorManager: ErrorsManager = new ErrorsManager()

    public notifyError(error: Error) {
        this.notifyErrorWithManager(error, PopupNotifier.errorManager)
    }

    public notifyErrorWithManager(error: Error, errorManager: ErrorsManager) {
        console.log({error: error})
        const message = errorManager.manageErrors(error)
        this.emitter.next(message)
    }

    public displaySnackBar(message:string) {
        this.emitter.next(new PopupMessage(message,PopupMessageType.SnackBar))
    }
}
